module.exports = __webpack_public_path__ + "img/bannericon2.93e4c758.png";